import React, {Component} from 'react';
import axios from 'axios';
import {FaBell} from "react-icons/fa";
import { connect } from 'react-redux';
import { Card, CardBody, Col, Table, Alert } from 'reactstrap';
import { MdCheck } from 'react-icons/md';
import { Spinner } from 'react-bootstrap';
import PaginateComponent from "../../../components/PaginateComponent";
import BreadcrumbCustomer from "../../../components/Layout/user/BreadcrumbCustomer";
import ListNotificationComponent from "../../../components/Customer/notifications/ListNotificationComponent";
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css';

class ListNotificationPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            isLoading: true,
            listNotification: [],
            perPage: 0,
            totalPage: 0,
            currentPage: 0,
            error: false,
            messageError: '',
            isNotification: '',
            textNotification: '',
            qtt: 30,
            checkAll: false,
            checkedNotiIds: [],
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getListNotification();

        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
        })
        if ( this.props.isNotification ) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
    }

    getListNotification = () => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let data = "?qtt=" + this.state.qtt;

        axios.get( process.env.REACT_APP_API_URL + '/api/notification/getListNotification' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listNotification: ref.data.content.data,
                        perPage: ref.data.content.perPage,
                        totalPage: ref.data.content.total,
                        currentPage: ref.data.content.current_page,
                        loadPage: false,
                        isLoading: false,
                    })
                } else {
                    if ( ref.data.error > 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu VPS thất bại',
                })
            })
    }

    changeQtt = async (event) => {
        let value = event.target.value;
        await this.setState({
            qtt: value
        })
        await this.getListVps();
    }

    paginate = () => {
        if (this.state.totalPage > this.state.perPage) {
            return (
                <PaginateComponent
                    total={this.state.totalPage}
                    perPage={this.state.perPage}
                    currentPage={this.state.currentPage}
                    btnPaginate={ (page) => this.btnPaginate(page) }
                />
            );
        }
    }

    btnPaginate = (page) => {
        this.setState({
            isLoading: true
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        // console.log(dataAuth);
        let data = "?qtt=" + this.state.qtt + "&page=" + page;

        axios.get( process.env.REACT_APP_API_URL + '/api/notification/getListNotification' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listNotification: ref.data.content.data,
                        perPage: ref.data.content.perPage,
                        totalPage: ref.data.content.total,
                        currentPage: ref.data.content.current_page,
                        loadPage: false,
                        isLoading: false,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu VPS thất bại',
                })
            })
    }

    screentListService = () => {
        if ( this.state.isLoading ) {
            return (
                <tr>
                    <td className="text-center" colSpan={12}>
                        <Spinner animation="grow" variant="primary" />
                        <Spinner animation="grow" variant="secondary" />
                        <Spinner animation="grow" variant="success" />
                        <Spinner animation="grow" variant="danger" />
                        <Spinner animation="grow" variant="warning" />
                        <Spinner animation="grow" variant="info" />
                    </td>
                </tr>
            );
        } else {
            // console.log(this.state.listNotification)
            if ( this.state.listNotification.length ) {
                return (
                    this.state.listNotification.map( (notification, key) => {
                        return (
                            <ListNotificationComponent
                                key={key}
                                notification={notification}
                                actionKey={key}
                                checkedNotification={ (actionKey) => this.checkedNotification(actionKey) }
                                checkedNotiShiftKey = { (actionKey, value) => this.checkedNotiShiftKey(actionKey, value) }
                            />
                        )
                    })
                )
            } else {
                return (
                    <tr>
                        <td className="text-center text-danger" colSpan="12">
                            Không có thông báo trong dữ liệu!
                        </td>
                    </tr>
                )
            }
        }
    }

    checkNotification = () => {
        if ( this.state.isNotification ) {
            return (
                <Alert color="success">
                    { this.state.textNotification }
                </Alert>
            );
        }
    }

    checkedNotification  = (actionKey) => {
        let listNotification = this.state.listNotification;
        // listNotification[actionKey].checked = true;
        listNotification[actionKey].checked = !listNotification[actionKey].checked;
        this.setState({
            listService: listNotification,
            checkedStart: actionKey
        });
        this.checkedNotiIds(listNotification)
    }

    checkAll = (event) => {
        let value = event.target.checked;
        let listNotification = this.state.listNotification;
        // eslint-disable-next-line array-callback-return
        listNotification.map( notification => {
            notification.checked = value;
            console.log(notification)
        })
        this.setState({
            checkAll: value,
            listNotification: this.state.listNotification
        });
        this.checkedNotiIds(listNotification);
    }

    checkedNotiShiftKey = (actionKey, value) => {
        if ( this.state.checkedStart !== -1 ) {
            let listNotification = this.state.listNotification;
            let n = Math.abs( actionKey - this.state.checkedStart );
            let i = this.state.checkedStart;
            let k = actionKey;
            if ( actionKey < this.state.checkedStart ) {
                i = actionKey;
                k = this.state.checkedStart;
            }
            for (i; i <= n; i++) {
                listNotification[i].checked = value;
            }
            this.setState({
                listNotification: listNotification,
                checkedStart: k
            });
            this.checkedNotiIds(listNotification);
        } else {
            let listNotification = this.state.listNotification;
            listNotification[actionKey].checked = !listNotification[actionKey].checked;
            this.setState({
                listNotification: listNotification,
                checkedStart: actionKey
            });
            this.checkedNotiIds(listNotification);
        }
    }

    checkedNotiIds = (listNotification) => {
        let checkedNotiIds = [];
        listNotification.forEach( notification => {
            if (notification.checked) {
                checkedNotiIds.push(notification.id)
            }
        });
        this.setState({
            checkedNotiIds: checkedNotiIds
        },
        () => { console.log(this.state.checkedNotiIds) }
        )
    }

    confirmCheckedNoti = () => {
        if (this.state.checkedNotiIds.length) {
            confirmAlert({
                  title: '',
                  message: 'Đã đọc các thông báo được chọn?',
                  buttons: [
                    {
                          label: 'Xác nhận',
                          onClick: () => { this.confirmCheckedNotiRequest() }
                    },
                    {
                          label: 'Hủy',
                          onClick: () => false
                    }
                  ]
            });
        } else {
            confirmAlert({
                  title: '',
                  message: 'Chưa chọn mục để đánh dấu?',
                  buttons: [
                    {
                          label: 'OK',
                          onClick: () => false
                    }
                  ]
            });
        }
    }

    confirmCheckedNotiRequest = () => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let params = {ids: this.state.checkedNotiIds}
        let config = {
              headers: {
                'Content-Type': 'application/json',
                'Authorization' : this.props.token,
                'dataAgency' : JSON.stringify(dataAuth)
            }
        }

        axios.post( process.env.REACT_APP_API_URL + '/api/notification/confirm-read-notification', params, config)
        .then( (ref) => {
            // console.log(ref.data);
            this.setState({
                isLoading: false,
                error: false,
                messageError: '',
                isNotification: '',
                textNotification: '',
            });
            if ( ref.data.error === 0 ) {
                this.setState({
                    isNotification: true,
                    textNotification: ref.data.message,
                    checkedNotiIds: [],
                },
                () => this.getListNotification()
                );
                this.getUnReadNotifications();
            } else {
                if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                    this.props.logOut();
                } else {
                    this.setState({
                        error: true,
                        messageError: ref.data.message,
                    })
                }
            }
        })
        .catch( (error) => {
            console.log(error);
            this.setState({
                isLoading: false
            });
            this.setState({
                error: true,
                messageError: 'Lấy dữ liệu thất bại',
            })
        })
    }

    getUnReadNotifications = () => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        let config = {
              headers: {
                'Content-Type': 'application/json',
                'Authorization' : this.props.token,
                'dataAgency' : JSON.stringify(dataAuth)
            } 
        }

        axios.get(process.env.REACT_APP_API_URL + '/api/notification/get-unread-notifications', config )
        .then((ref) => {
            // console.log(ref.data);
            if (ref.data.error === 0) {
                this.updateNotification(ref.data)
            } else {
                if (ref.data.error > 9000) {
                    this.props.logOut();
                } else {
                    this.setState({
                        error: true,
                        messageError: ref.data.message
                    })
                }
            }
        })
        .catch((error) => {
            console.log(error);
            this.setState({
                error: true,
                messageError: 'Lấy dữ liệu thông báo thất bại',
            })
        })
      }

    updateNotification = (data) => {
        console.log(data);
        let itemNotification = {
          notifications: data.notifications,
          unread_notification: data.unread_notification
        }
        this.props.updateNotification(itemNotification);
    }


    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <BreadcrumbCustomer title={"Thông báo"} page={"Thông báo"} icon={<FaBell className="breadcrumb-icon"/>}/>
                            <Card>
                                <CardBody>
                                    <div className="row">
                                        <div className="col-md-12">
                                            {
                                                this.checkNotification()
                                            }
                                        </div>
                                        <Col sm={12}>
                                            <button
                                                className={`btn btn-${this.state.checkedNotiIds.length ? 'success' : 'outline-success'} btn-sm mb-3 mx-2 `}
                                                onClick={ () => this.confirmCheckedNoti() }
                                            >
                                                <MdCheck /> Đánh dấu đã đọc
                                            </button>
                                        </Col>
                                        <div className="col col-md-12 table-responsive">
                                            <Table className="table table-sm table-bordered table-hover rounded table-service">
                                                <thead>
                                                    <tr className="text-center">
                                                        <th width="8%"><input type="checkbox" value={ this.state.checkAll } onChange={ this.checkAll } /></th>
                                                        <th width="20%">Thời gian</th>
                                                        <th>Thông báo</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-center">
                                                    { this.screentListService() }
                                                </tbody>
                                            </Table>
                                            { this.paginate() }
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
        notifications: state.user.notifications,
        unread_notification: state.user.unread_notification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'CustomerNotification' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
        updateNotification: (item) => {
            dispatch(({type: 'updateNotification', item}))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ListNotificationPage);